import React from "react"
import { Link} from "gatsby"

import homeStyle from "./home.module.scss"

import backgroundImg from "../img/back1.png"

const home = () => {
  return (
    <div className={homeStyle.home}>
      <img
        className={homeStyle.backgroundImg}
        src={backgroundImg}
        alt="background"
      />
      <main>
        <div className={homeStyle.root}>
          <div className={homeStyle.homeText}>
            <p>Hi, my name is</p>
            <h2>SOOYOUNG MOON</h2>
            <p>Computer Science Student at the University of Arizona</p>
            <Link to="/contact"><button>GET IN TOUCH</button></Link>
          </div>
        </div>
      </main>
    </div>
  )
}


export default home
